import { Font, fontUrls } from './Font';

export const getFontUrl = (font: Font = Font.ROBOTO): string =>
  fontUrls[font] ?? fontUrls[Font.ROBOTO];
